import React from 'react';
import { connect } from 'react-redux';
import SearchInput from '../SearchInput';
import Table from '../Table';
import { bindMethods, safeToLower } from '../../utils/core';
import { merge } from 'ramda';
import Pager from '../Pager';
import fetchAllServices from '../../actions/reduxActions/services';

const initialState = {
    paging: {
        page: 1,
        pageSize: 20,
        total: 0,
    },
    query: '',
};

export class ServiceList extends React.Component {

    constructor() {
        super();

        this.state = initialState;

        bindMethods(
            this,
            'onSearch',
            'onPage',
            'onAddService',
        );
    }

    componentDidMount() {
        this.props.fetchAllServices(this.props.authenticationToken);
    }

    onSearch(query) {
        this.setState({ query });
    }

    onPage(pageNumber) {

        const paging = merge(this.state.paging, { page: pageNumber });

        this.setState({
            paging,
        });
    }

    onAddService() {
        this.props.switchToNewService();
    }

    render() {
        const { query, paging: { page, pageSize } } = this.state;
        const { services } = this.props;

        const pageStart = pageSize * (page - 1);
        const pageEnd = pageStart + pageSize;

        let queriedServices = services;

        if (query !== '') {
            queriedServices = services.filter(
                item => (item.developerName && safeToLower(item.developerName).indexOf(safeToLower(query)) !== -1)
                    || (item.uri && safeToLower(item.uri).indexOf(safeToLower(query)) !== -1)
                    || (item.developerSummary && safeToLower(item.developerSummary).indexOf(safeToLower(query)) !== -1),
            );
        }

        const visibleServices = queriedServices.slice(pageStart, pageEnd);

        return (
            <div className="admin-page">
                <h2>Services</h2>

                <div className="flex">
                    <SearchInput onSearch={this.onSearch} />
                    <button onClick={this.onAddService} className="btn btn-sm btn-success flex-child-right">
                        <span className="glyphicon glyphicon-plus" />
                        {
                            ' Add Service'
                        }
                    </button>
                </div>

                <Table
                    className="table margin-top table-striped"
                    columns={
                        [
                            {
                                renderHeader: () => 'Actions',
                                renderCell: ({ item }) => (
                                    <div className="flex">
                                        <button
                                            className="btn-icon"
                                            title="Edit"
                                            onClick={() => this.props.onEditService(item)}
                                        >
                                            <span className="glyphicon glyphicon-pencil" />
                                        </button>
                                        <button
                                            className="btn-icon danger"
                                            title="Delete"
                                            onClick={() => this.props.onDeleteService(item)}
                                        >
                                            <span className="glyphicon glyphicon-trash" />
                                        </button>
                                    </div>
                                ),
                                size: '1px',
                            },
                            {
                                renderHeader: () => 'Name',
                                renderCell: ({ item }) => item.developerName,
                            },
                            {
                                renderHeader: () => 'Uri',
                                renderCell: ({ item }) => item.uri,
                            },
                            {
                                renderHeader: () => 'Summary',
                                renderCell: ({ item }) => item.developerSummary,
                            },
                        ]
                    }
                    items={visibleServices}
                />
                <Pager page={page} pageSize={pageSize} total={queriedServices.length} onPageClick={this.onPage} />
            </div>
        );
    }
}

const mapStateToProps = ({ services }) => ({
    services,
});

const mapDispatchToProps = {
    fetchAllServices,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ServiceList);
